export const MuiListItemIcon = {
    MuiListItemIcon: {
        styleOverrides: {
            root: {
                minWidth: 16,
                marginRight: 16,
            },
        },
    },
};
